
export const LoadableContainer = ({ loading, loader, children }) => {
  if (loading) return loader;
  return children;
};
